/**
 * Root route layout
 *
 * This is the top-level layout that wraps all routes
 */

import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import AppShell from '../components/layouts/AppShell';
import { EmptyState } from '../components/shared';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent(): JSX.Element {
  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}

function NotFoundPage(): JSX.Element {
  return (
    <EmptyState
      icon="search_off"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved."
    />
  );
}
